var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_CerrarMini",
    "data-name": "Icon/CerrarMini",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4588",
    "data-name": "Grupo 4588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4226",
    "data-name": "Grupo 4226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_79",
    "data-name": "L\\xEDnea 79",
    d: "M17.977,19.25a1.269,1.269,0,0,1-.9-.373L-.377,1.423a1.273,1.273,0,0,1,1.8-1.8L18.877,17.077a1.273,1.273,0,0,1-.9,2.173Z",
    transform: "translate(0.75 0.75)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_80",
    "data-name": "L\\xEDnea 80",
    d: "M.523,19.25a1.273,1.273,0,0,1-.9-2.173L17.077-.377a1.273,1.273,0,0,1,1.8,1.8L1.423,18.877A1.269,1.269,0,0,1,.523,19.25Z",
    transform: "translate(0.75 0.75)",
    fill: "current"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.393a14b7.svg";
export { ForwardRef as ReactComponent };